export const howItWorksSteps = [
  {
    step: 1,
    title: 'Search',
    description: 'Find verified local guides by destination, language, and experience type.',
    icon: 'search' as const,
  },
  {
    step: 2,
    title: 'Choose',
    description: 'Compare profiles, reviews, and specialties to pick your perfect match.',
    icon: 'choose' as const,
  },
  {
    step: 3,
    title: 'Book',
    description: 'Send a connection request and confirm your experience securely.',
    icon: 'book' as const,
  },
  {
    step: 4,
    title: 'Explore',
    description: 'Meet your guide and discover destinations like a true local.',
    icon: 'explore' as const,
  },
];

export const testimonials = [
  {
    id: '1',
    text: 'Our guide in Jaipur made the Pink City come alive with stories you would never find in a guidebook. The palace tour was absolutely magical.',
    name: 'Sarah Mitchell',
    location: 'London, UK',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80',
    rating: 5,
    destination: 'Jaipur',
  },
  {
    id: '2',
    text: 'Found an amazing food tour guide in Mumbai through trplin. Every stop was authentic local cuisine and the street food recommendations were incredible.',
    name: 'James Wilson',
    location: 'New York, USA',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80',
    rating: 5,
    destination: 'Mumbai',
  },
  {
    id: '3',
    text: 'The sunrise boat ride on the Ganges with our local guide was a life-changing experience. Professional, knowledgeable, and deeply respectful of the culture.',
    name: 'Emma Anderson',
    location: 'Sydney, Australia',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80',
    rating: 5,
    destination: 'Varanasi',
  },
  {
    id: '4',
    text: 'Exploring the backwaters of Kerala with a local guide was incredible. They knew every hidden spot and the houseboat experience was unforgettable.',
    name: 'David Park',
    location: 'Seoul, South Korea',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
    rating: 5,
    destination: 'Kerala',
  },
];

export const featuredGuides = [
  {
    id: '1',
    name: 'Rajesh Kumar',
    location: 'Jaipur, Rajasthan',
    specialty: 'Heritage & History',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80',
    rating: 4.9,
    reviews: 156,
    languages: ['English', 'Hindi', 'French'],
    pricePerHour: 800,
  },
  {
    id: '2',
    name: 'Priya Sharma',
    location: 'Mumbai, Maharashtra',
    specialty: 'Food & Culture',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=400&q=80',
    rating: 4.8,
    reviews: 203,
    languages: ['English', 'Hindi', 'Marathi'],
    pricePerHour: 1000,
  },
  {
    id: '3',
    name: 'Amit Verma',
    location: 'Varanasi, UP',
    specialty: 'Spiritual & Cultural',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=400&q=80',
    rating: 4.9,
    reviews: 189,
    languages: ['English', 'Hindi', 'German'],
    pricePerHour: 750,
  },
  {
    id: '4',
    name: 'Meera Nair',
    location: 'Kochi, Kerala',
    specialty: 'Nature & Adventure',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80',
    rating: 4.9,
    reviews: 142,
    languages: ['English', 'Malayalam', 'Hindi'],
    pricePerHour: 900,
  },
];
